module.exports = __webpack_public_path__ + "img/error.4d1bd72d.png";